import { ShowExportarPlantillaModalForm } from "./ShowExportarPlantillaModalForm"


const ShowExportarPlantillaModalFormWrapper = () => {
    return (<ShowExportarPlantillaModalForm />)
}

export {ShowExportarPlantillaModalFormWrapper}